<div class="bc-text-chat-buttons">
    <div class="bc-buttons-inline bc-border-top clearfix">
        <button *ngIf="hasWrapUps" class="btn btn-light" (click)="wrapupButtonClick()" id="text-chat-buttons-wrap-up">
          <span>{{ 'bcTextChatButtons.wrapupButton' | translate }}</span>
        </button>

        <div class="pull-right clearfix">
            <div class="pull-left clearfix">
                <button class="btn btn-light js-open-chat-transfer-button" (click)="transferButtonClick()" id="text-chat-buttons-transfer">
                  <span>{{ 'bcTextChatButtons.transferButton' | translate }}</span>
                </button>

                <button class="btn btn-light js-end-chat-button pull-right clearifx" *ngIf="isEndable" (click)="endTextChatClick()" id="text-chat-buttons-end-chat">
                  <span>{{ 'bcTextChatButtons.endButton' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</div>
